import { memo, useState } from "react";

import type { ReportingTableHeader, TableRow } from "../../../types";
import { ROW_BACKGROUND, type StickyPosition } from "../utils";
import { ReportingTableBodyCell } from "./bodyCell";

type Props = {
  headers: ReportingTableHeader[];
  row: TableRow;
  stickyPositions: Record<string, StickyPosition>;
  isIndividualTab: boolean;
  isSelected: boolean;
  onToggleRow: (key: string) => void;
};

export const ReportingTableBodyRow: React.FC<Props> = memo(
  ({
    headers,
    row,
    stickyPositions,
    isIndividualTab,
    isSelected,
    onToggleRow,
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    const background = isSelected
      ? ROW_BACKGROUND.selected
      : isHovered
        ? ROW_BACKGROUND.hovered
        : ROW_BACKGROUND.default;

    return (
      <tr
        style={{ background }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {headers.map((header) => (
          <ReportingTableBodyCell
            key={header.id}
            columnId={header.id}
            row={row}
            isIndividualTab={isIndividualTab}
            stickyPosition={stickyPositions[header.id]}
            background={background}
            isSelected={isSelected}
            onToggleRow={onToggleRow}
          />
        ))}
      </tr>
    );
  },
);
